/* eslint-disable func-call-spacing */
const ProjectDetail = () => import('~pages/Project/Details/ProjectDetail.vue')
const ProjectDetailV2 = () => import('~pages/Project/Details/ProjectDetailV2.vue')
const LandClassification = () => import('~pages/Project/Details/LandClassification.vue')
const LandSheetUpload = () => import('~pages/Project/Details/LandSheetUpload.vue')

export default [
  {
    path: 'details',
    name: 'project-details',
    component: ProjectDetail,
    meta: {
      access: ['project.view', 'org.project.view']
    }
  },
  {
    path: 'details-v2',
    name: 'project-details-v2',
    component: ProjectDetailV2,
    meta: {
      access: ['project.view', 'org.project.view']
    }
  },
  {
    name: 'land-classification',
    path: 'classification',
    component: LandClassification,
    meta: {
      access: ['project.classification.manage', 'project.manage', 'org.project.manage']
    }
  },
  {
    name: 'land-sheet-upload',
    path: 'land-sheet-upload',
    component: LandSheetUpload,
    meta: {
      access: ['project.land.import', 'project.manage', 'org.project.manage']
    }
  }
]
